/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import clsx from 'clsx';

import { ReactComponent as DragHandleIcon } from '@assets/icons/drag-handle.svg';
import { DeleteButton } from '@molecules';

import Button from '../Button';
import s from './styles.module.less';

const SortableTreeItem = ({
  as: Component = 'li',
  componentBackground,
  children,
  footer,
  extra,
  innerRef,
  draggableProps,
  dragHandleProps,
  ...props
}) => (
  <Component
    className={clsx(s.sortable, componentBackground && s.componentBackground)}
    ref={innerRef}
    {...draggableProps}
  >
    <div className={clsx(s.wrapper, footer && s.hasFooter)}>
      {children && <div className={s.content}>{children}</div>}
      {extra && <div className={s.extra}>{extra}</div>}
      <div className={s.dragHandle} align="middle" {...dragHandleProps}>
        <DragHandleIcon />
      </div>
    </div>
    {footer && <div className={clsx(s.footer)}>{footer}</div>}
  </Component>
);

const SortableItem = ({ draggableId, index, ...props }) => (
  <Draggable draggableId={draggableId} index={index}>
    {(provided) => <SortableTreeItem {...props} {...provided} />}
  </Draggable>
);

const SortableItemWithDelete = ({ as: Component = SortableItem, onDelete, ...props }) => (
  <Component
    {...props}
    extra={
      <div style={{ padding: '0 15px' }}>
        <DeleteButton onDelete={onDelete} />
      </div>
    }
  />
);

const SortableItemWithButton = ({ onButtonClick, buttonTitle, ...props }) => (
  <SortableItem
    {...props}
    extra={
      <Button onClick={onButtonClick} style={{ margin: '0 30px 0 10px' }}>
        {buttonTitle}
      </Button>
    }
  />
);

export default SortableItem;
export {
  SortableTreeItem as TreeItem,
  SortableItemWithDelete as ItemWithDelete,
  SortableItemWithButton as ItemWithButton,
};
